/**
 * PDFSearchBar - Floating search bar component
 *
 * Extracted from PDFViewerModal.tsx
 */

import React from 'react';
import { Search, X } from 'lucide-react';
import type { Theme } from '../../../themes/theme';

export interface PDFSearchBarProps {
  theme: Theme;
  searchInput: string;
  searchText: string;
  searchInputRef: React.RefObject<HTMLInputElement>;
  onSearchChange: (query: string) => void;
  onSearchSubmit: (e: React.FormEvent) => void;
  onClear: () => void;
}

export function PDFSearchBar({
  theme,
  searchInput,
  searchText,
  searchInputRef,
  onSearchChange,
  onSearchSubmit,
  onClear,
}: PDFSearchBarProps) {
  return (
    <div
      className={`absolute top-2 right-2 ${theme.colors.bg.primary} border ${theme.colors.border.primary} rounded-lg shadow-lg p-2 min-w-[280px] z-10`}
    >
      <form onSubmit={onSearchSubmit} className="flex flex-col gap-1.5">
        <div className="flex items-center gap-1.5">
          <Search size={14} className={theme.colors.text.secondary} />
          <input
            ref={searchInputRef}
            type="text"
            id="pdf-viewer-search"
            name="pdf-viewer-search"
            value={searchInput}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Buscar..."
            className={`flex-1 px-2 py-1 text-xs ${theme.colors.bg.input} ${theme.colors.text.primary} border ${theme.colors.border.primary} rounded focus:outline-none focus:ring-2 focus:ring-gray-400`}
          />
          <button
            type="button"
            onClick={onClear}
            className={`p-0.5 ${theme.colors.text.secondary} hover:${theme.colors.text.primary} rounded transition-colors`}
            title="Cerrar"
          >
            <X size={14} />
          </button>
        </div>

        {searchText && (
          <div className="flex items-center justify-between text-[10px]">
            <span className={theme.colors.text.secondary}>Enter para buscar</span>
            <span className={`${theme.colors.text.secondary} font-mono`}>Ctrl+F</span>
          </div>
        )}
      </form>
    </div>
  );
}
